import axios from "axios";

const baseCommonURL = process.env.VUE_APP_WebApiBaseUrl
const baseURLCommon = `${baseCommonURL}`;

const instance = axios.create({
    baseURL: baseURLCommon,
    timeout: 10000

});

export default instance;